<template>
  <div class="cp-bind mobile">
    <Select :options="zoneList" :close="closeZone" class="select1" @select="setZone" @toggle="val => closeRole = val"></Select>
    <Select :options="roleList" :close="closeRole" class="select2" @select="setRole" @toggle="val => closeZone = val"></Select>
    <div v-if="showDownload" class="input">暂无角色信息，请下载游戏并创建角色</div>
    <div class="btns" :class="{two: showDownload}">
      <div class="button" @click="bindRole"></div>
      <a v-if="showDownload && !ingame" href="javascript:;" class="button downloadbtn ios" target="_self" @click="iosHandler"></a>
      <a v-if="showDownload" href="javascript:;" class="button downloadbtn android" target="_self" @click="downloadHandler"></a>
    </div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
// 移动端头部
import { isMobile, isAndroid, getParameterByName } from '~/tools/utils'
import Close from '~/components/Close/close.vue';
import api from '~/api/api';
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Select from "~/components/Select/select.vue";
import { mapState } from "vuex";
import Alert from "~/components/Alert";

export default {
  name: 'Info',
  components: {Close, Select},
  props: {
    win: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isAndroid: isAndroid(),
      closeZone: false,
      closeRole: false,
      zoneList: [],
      roleList: [],
      zone_num: '',
      role_id: {},
      isMobile: isMobile(),
      loading: false,
      showDownload: false,
      ingame: getParameterByName("ingame")
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  mounted() {
    api.getZone().then(res => {
      if(res.status === 1) {
        this.zoneList = res.list
      }
    })
  },
  methods: {
    iosHandler() {
      _paq.push(['trackEvent', 'BLC-Download', 'Home', 'ios', 'ios'])
    },
    downloadHandler() {
      let platform = this.isAndroid ? 'android' : 'ios'
      _paq.push(['trackEvent', 'BLC-Download', 'Home', platform, platform])
      if(this.ingame) {
        let url = `https://yszt.ztgame.com/download/${platform}.html`
        store.commit(types.SHOW_MODAL, {type: 'copy', copy: url})
      }
    },
    setZone(key) {
      this.zone_num = key.zone_num;
      api.getRole(this.zone_num).then(res => {
        if(res.status === 1) {
          this.roleList = res.list
          if(!res.list || !res.list.length) {
            this.showDownload = true
            if(!this.ingame) {
              requirejs(["jquery"], ($) => {
                new Download({
                  iosBtn: $(".ios"),
                  androidBtn: $(".android"),
                  display: "block",
                  tip: "iOS版本敬请期待",
                  callback: function (info) {},
                });
              });
            }
          }
        }
      })
    },
    setRole(key) {
      this.role = key;
    },
    bindRole() {
      if(!this.zone_num || !this.role.role_id) {
        Alert("请选择区服和角色");
        return
      }
      if(this.loading) {
        return
      }
      store.commit(types.SHOW_LOADING, true)
      this.loading = true;
      api.bindRole({
        zone_num: this.zone_num, role_id: this.role.role_id
      }).then(res => {
        if(res.status === 1) {
          store.commit(types.HIDE_MODAL);
          window.scrollTo(0, 0);
          Alert("绑定成功！<br>现在可以领取奖励啦！", 'draw').then(() => {
            store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {
              toDraw: true
            }))
          })
          store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {
            charname: this.role.role_name,
            isbind: 1,
            toBind: false
          }))
        }
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      }).catch(() => {
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      })
    },
    handleClose() {
      store.commit(types.HIDE_MODAL);
      store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toBind: false}));
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-bind
    position absolute
    width 6.92rem
    height 8.37rem
    background-image url('./images/bind-modal.png')
    background-size: 6.92rem 7.41rem;
    background-repeat: no-repeat;
    background-position 0 0
    .prize-wrapper
      margin 1.17rem 0 0 0.42rem
    .select1
      position absolute
      left 2.15rem
      top 2.27rem
    .select2
      position absolute
      left 2.15rem
      top 3.47rem
    .input
      width: 100%;
      text-align center
      font-size 0.22rem;
      color: #c22516;
      margin-top 2.98rem
    .btns
      width 5.07rem;
      position absolute
      top 5.5rem
      left 0.94rem
      display flex
      justify-content center
      &.two
        justify-content space-between
    .button
      width 2.27rem
      height 0.8rem
      background-size: 100% 100%;
      background-image url('./images/bind.png')
      background-repeat: no-repeat;
      &.downloadbtn
        background-image url('./images/download.png')
</style>
